import { render, staticRenderFns } from "./VerificationViewer.vue?vue&type=template&id=4aa5328b&scoped=true"
import script from "./VerificationViewer.vue?vue&type=script&lang=js"
export * from "./VerificationViewer.vue?vue&type=script&lang=js"
import style0 from "./VerificationViewer.vue?vue&type=style&index=0&id=4aa5328b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5328b",
  null
  
)

export default component.exports